import React from "react";

import { Platform, View } from "react-native";
import { Img, Text } from "component";

import { colors, sizes } from "asset/constant";
import { css } from "style";
import { sn } from "utils";

export default function Company(props: { company: CompanyCardT }) {
  const { company } = props;

  return (
    <View
      style={{
        height: sn(70, 70, 75, 80),
        ...css.rRow,
        ...css.alignFEnd,
        alignItems: "center",
        marginHorizontal: sizes.space,
        borderBottomWidth: 2,
        borderColor: colors.border.light,
      }}
    >
      <Img
        source={{ uri: company?.avatar }}
        style={{
          ...css.circle(55),
          borderWidth: 2,
          borderColor: colors.border.normal,
          backgroundColor: colors.white,
        }}
        resizeMode={"stretch"}
      />
      <View
        style={{
          marginRight: 10,
          height: "100%",
          justifyContent: "center",
        }}
      >
        <View style={Platform.select({ web: { marginBottom: 5 } })}>
          <Text weight="bold">سفارش از: </Text>
        </View>
        <View style={{ ...css.rRowCenterAlign }}>
          <Text size={"lg"} weight="extraBold">
            {company?.name}
            {company?.company_name}
          </Text>
          <Text size={"sm"}> ({company?.cto_name})</Text>
        </View>
      </View>

      <View style={css.container} />
    </View>
  );
}
